import axios from "axios";
import React, { createContext, useEffect, useState } from "react";
import { BASE_URL } from "../config";

export const PageContext = createContext();



export const PageProvider = ({children}) => {
    // const [pMobile, setpMobile] = useState("")
    // const [churchNm, setchurchNm] = useState("")
    const [myreqUser, setMyreqUser] = useState({})
    const [myAllAdmins, setMyAllAdmins] = useState([])
    const [myAllPlans, setMyAllPlans] = useState([])
    const [staticLoaded, setStaticLoaded] = useState(false)
    const [dataLoaded, setdataLoaded] = useState(false)

    const submitMobileNum = async (mobNum, eOtp, veriMeth, assAdminId) => {

        const bodytxt = { mobNum:mobNum, eOtp:eOtp, veriMeth:veriMeth, assAdminId:assAdminId }

        console.log(bodytxt);

        const res = await axios.post(`${BASE_URL}requsers/verifyOtp`, bodytxt)
        let succStat
        if(res.data.success){
            setMyreqUser(res.data.data)
            setdataLoaded(true)
            sessionStorage.setItem('myReqUserSess', JSON.stringify(res.data.data))
            sessionStorage.setItem('dataLoadedSess', true)
            succStat = "Success"
        }
        else{
            setMyreqUser({})
            setdataLoaded(false)
            sessionStorage.clear()
            succStat = res.data.message
        }
        return succStat
    }



    const restoreToken = async() => {
        try{
            const myReqUserSess = sessionStorage.getItem('myReqUserSess')
            const dataLoadedSess = sessionStorage.getItem('dataLoadedSess')
            console.log(myReqUserSess);
            const myReq = JSON.parse(myReqUserSess)
            const bodytxt = {
                mobNum:myReq.gbMobileNumber,
                assAdd:myReq.assAdmin,
            };
            const rrr = await axios.post(`${BASE_URL}requsers/update/`,bodytxt)
            if(rrr.data.success){
                setMyreqUser(rrr.data.data)
                setdataLoaded(dataLoadedSess)
            }
        }
        catch(e) {
            setMyreqUser({})
            setdataLoaded(false)
            sessionStorage.clear()
        }
    }

    const clearCache = () => {
        setMyreqUser({})
        setdataLoaded(false)
        sessionStorage.clear()
    }
    

    const getStatics = async() => {
        axios.get(`${BASE_URL}plans/`).then((resPlan) => {
            setMyAllPlans(resPlan.data)
            axios.get(`${BASE_URL}adusers/`).then((res) => {
                setMyAllAdmins(res.data.data)
                setStaticLoaded(true)
            })
            .catch((err) => {
                console.log("Unable to get Admins");
            })
        })
        .catch((err) => {
            console.log("Unable to get Plans");
        })
    }

    useEffect(()=>{
        restoreToken();
        getStatics();
    }, [])

    return(
        <PageContext.Provider value={{dataLoaded, myreqUser, myAllAdmins, myAllPlans, staticLoaded, submitMobileNum, clearCache, setMyreqUser }}>
            {children}
        </PageContext.Provider>
    );
}